import { all } from "redux-saga/effects";
import { familyProductSagas } from "../modules/family-product/saga";
import { fdesSagas } from "../modules/fdes/saga";
import { calculsSagas } from "../modules/calcul/saga";
import { foldersSagas } from "../modules/folders/saga";
import { configuratorSagas } from "../modules/configurator/saga";
import { manageGroupSagas } from "../modules/manage-group/saga";
import { assistanceSagas } from "../modules/assistance/saga";

import { userSagas } from "../modules/user/sagas";

export function* rootSaga() {
  yield all([
    ...userSagas,
    ...familyProductSagas,
    ...manageGroupSagas,
    ...fdesSagas,
    ...calculsSagas,
    ...configuratorSagas,
    ...assistanceSagas,
    ...foldersSagas,
  ]);
}
